import React from 'react';
import { Button } from 'antd';
import { twMerge } from 'tailwind-merge';
import { useNavigate } from 'react-router-dom';
import { IMenuItem } from '@/interfaces/menuItem';
import { useAuth } from '@/contexts/AuthContext';
import { EUserRole } from '@/enums/EUserRole';

interface IProps {
  active: string;
  items: IMenuItem[];
}

const SubMenu = ({ items, active }: IProps) => {
  const { userInfo } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="bg-white px-5 border border-b-1 flex flex-row py-2 overflow-y-auto">
      {items
        ?.filter(item =>
          item.roles ? item.roles.includes(userInfo?.role as EUserRole) : true,
        )
        .map(i => {
          return (
            <Button
              key={i.key}
              type="text"
              className={twMerge(
                'font-bold',
                active === i.key && 'text-blue-700',
              )}
              onClick={() => navigate(`/${i.key}`)}
            >
              {i.name}
            </Button>
          );
        })}
    </div>
  );
};

export default SubMenu;
